module.exports = __webpack_public_path__ + "img/zggjgczxyxgs1.161b2e26.png";